/** Pareto / ABC (D529): items sorted by value with the cumulative share and the class of each. */
import { isFiniteNumber } from './numbers.js';
/**
 * Sort descending (ties by label, so the order is stable) and accumulate. Negative and missing values count as 0.
 * `thresholds` are the cumulative shares where A ends and B ends (default 80 % and 95 %).
 */
export function paretoSeries(inputs, options = {}) {
    const [tA, tB] = options.thresholds ?? [0.8, 0.95];
    const rows = inputs.map((i) => ({ key: i.key, label: i.label, value: isFiniteNumber(i.value) ? Math.max(0, i.value) : 0 }));
    rows.sort((a, b) => b.value - a.value || (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));
    const total = rows.reduce((s, r) => s + r.value, 0);
    let run = 0;
    const counts = { A: 0, B: 0, C: 0 };
    const items = rows.map((r) => {
        const before = total === 0 ? 0 : run / total;
        run += r.value;
        const cls = before < tA ? 'A' : before < tB ? 'B' : 'C';
        counts[cls] += 1;
        return { ...r, share: total === 0 ? 0 : r.value / total, cumulative: total === 0 ? 0 : run / total, cls };
    });
    return { items, total, classCounts: counts };
}
//# sourceMappingURL=pareto.js.map